module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"10\"><path fill=\"#A2B0D5\" fill-rule=\"evenodd\" stroke=\"#A2B0D5\" d=\"M8 9.5C3.86 9.5.5 7.49.5 5S3.86.5 8 .5c4.14 0 7.5 2.01 7.5 4.5S12.14 9.5 8 9.5zm0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/eye-filled.svg
// module id = Zdf/
// module chunks = 5